import { useContext } from 'react';
import { useAppSelector } from '../../../../Hooks/Hooks';
import { RootState } from '../../../../Redux/Store';
import { AppContext } from '../../../../Context/AppContext';
import {
  commonDateFormat,
  convertToTimezoneFormatwithSmallhh,
  isBeforeCurrentDateAndTime,
} from '../../../../Utils/DateUtils';
import { EVENT, SCREEN } from '../../../../Constants/AnalyticsConstants';
import { fbLogEvent } from '../../../../Helpers/FirebaseHelper';
import SearchSelectList from '../../../SearchSelectList/SearchSelectList';
import DatePickerComponent from '../../../Shared/DatePickerComponent/DatePickerComponent';
import './NatNalEdit.scss';

interface INatNalEditProps {
  userSelectedNextAvailableTime: string;
  handleSave: () => void;
  handleDateChange: (type: string, value: string) => void;
  selectedLocation: string;
  handleSelectedLocationChange: (locationId: string) => void;
}

const NatNalEdit = (props: INatNalEditProps) => {
  const {
    handleSave,
    userSelectedNextAvailableTime,
    handleDateChange,
    selectedLocation,
    handleSelectedLocationChange,
  } = props;
  const { isMobile } = useContext(AppContext);
  const { lastLocation, nextAvailableLocation, nextAvailableTime, parkLocationRestrictions } =
    useAppSelector((state: RootState) => state.NatNal);

  const locationOptions = parkLocationRestrictions?.map((location: any) => ({
    value: `${location?.addressLine1}, ${location?.city} ${location?.state}, ${location?.postalCode}`,
    id: location?.locationId,
    timeZone: location?.timezone,
  }));

  const convertUserSelectedNextAvailableTime = convertToTimezoneFormatwithSmallhh(
    userSelectedNextAvailableTime,
    nextAvailableLocation?.timezone,
  );
  return (
    <div className="NatNalEdit_Wrapper" data-testid="NatNatlEdit">
      <div className="Header_section">
        <img src="/oo/assets/icon/Next Available.svg" alt="Calendar" />
        <span>Next Available</span>
      </div>
      <div className="Available_Edit_section">
        <div className="Available_column DatePicker">
          <p className="Available_Title">Available Date & Time</p>
          <DatePickerComponent
            type={'NatNalEdit'}
            value={
              convertUserSelectedNextAvailableTime === null ||
              isBeforeCurrentDateAndTime(
                convertUserSelectedNextAvailableTime,
                nextAvailableLocation?.timezone,
              )
                ? commonDateFormat(new Date().getTime(), false, false)
                : commonDateFormat(new Date(userSelectedNextAvailableTime), false, false)
            }
            handleChange={handleDateChange}
            minDate={
              convertUserSelectedNextAvailableTime === null ||
              isBeforeCurrentDateAndTime(
                convertUserSelectedNextAvailableTime,
                nextAvailableLocation?.timezone,
              )
                ? commonDateFormat(new Date().getTime(), false, false)
                : commonDateFormat(
                    new Date(
                      lastLocation?.shipmentAssignmentStopDTO?.actualDepartureTime?.trim() !== ''
                        ? lastLocation?.shipmentAssignmentStopDTO?.actualDepartureTime
                        : lastLocation?.shipmentAssignmentStopDTO?.plannedDepartureTime,
                    ),
                    false,
                    false,
                    nextAvailableLocation?.timezone || null,
                  )
            }
            showTimeSelector={true}
            customClass={'NATNAL_DatePicker'}
          />
        </div>
        <div className="Available_column">
          <p className="Available_Title">Available Location</p>
          <div className="Selection_Container" data-testid="SelectionContainer">
            <SearchSelectList
              options={locationOptions}
              type={'NatNalEdit'}
              name={'Type Available Location'}
              value={selectedLocation}
              handleChange={handleSelectedLocationChange}
            />
          </div>
        </div>
      </div>
      <div className="Save_section">
        <button
          className="primary-cta-btn"
          onClick={() => {
            fbLogEvent(EVENT.UE_NAT_NAL_EDIT_SAVE, {
              screen: SCREEN.NAT_NAL_EDIT,
              lead: isMobile ? SCREEN.TAB_BAR : SCREEN.LEFT_MENU,
              lastLoadId: lastLocation?.shipmentId,
              nextAvailableTime: nextAvailableTime,
              nextAvailableLocation: JSON.stringify({
                locationName: nextAvailableLocation?.locationName,
                addressLine1: nextAvailableLocation?.addressLine1,
                addressLine2: nextAvailableLocation?.addressLine2,
                city: nextAvailableLocation?.city,
                state: nextAvailableLocation?.state,
                postalCode: nextAvailableLocation?.postalCode,
              }),
            });
            handleSave();
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default NatNalEdit;
